export * from './value-of.pipe';
